import { createSelector } from '@reduxjs/toolkit';
export const selectAdvancedSearchQueries = createSelector((state) => state.advancedSearchQueries, (advancedSearchQueries) => {
    if (!advancedSearchQueries) {
        return {};
    }
    const { aq, cq, dq, lq } = advancedSearchQueries;
    return {
        ...(aq && { aq }),
        ...(cq && { cq }),
        ...(dq && { dq }),
        ...(lq && { lq }),
    };
});
